// ** HEADERS **

//CLICK ON CHEVRON ICON TO SORT HEADERS

document.addEventListener("click", function(e) {
  if (e.target.parentNode && e.target.parentNode.classList.contains('icon-cheveron-header')) {
    var previousElement = e.target.parentNode.previousElementSibling;
    if (previousElement && typeof previousElement.click === 'function') {
      previousElement.click();
    }
  }
})

document.addEventListener("click", function(e) {
  if ((e.target.classList.contains('icon-caret-right')) || (e.target.classList.contains('icon-caret-down')) || (e.target.classList.contains('icon-caret-up'))) {
    const link = e.target.closest('div').getElementsByTagName("a")[0];
    if (link) { link.click(); }
  }
});

window.hash_param = "";

//SORTABLE HEADERS

window.targetHeaders = document.querySelectorAll("th a");

//STYLING HEADERS ON SCROLL

window.scrolledHeaders = function scrolledHeaders() {
 if (document.querySelector(".table-div").scrollTop > 1) {
  document.querySelector("thead").classList.add("is-scrolled");
} else {
  document.querySelector("thead").classList.remove("is-scrolled");
}
};

window.clientAll = 0;
window.inputItemsId1 = document.querySelector('#items_export_clients_id1');
window.inputItemsId2 = document.querySelector('#items_export_clients_id2');
window.checks = document.querySelectorAll('.j-selectable');
window.actionDescription = document.querySelector('.action-description-updated');
window.actionSelectAll = document.querySelector('.action-select-all');
window.targetDiv = document.querySelector('.table-action-bar');
window.defaultBoxSelectAll = document.querySelector('.j-select-all');
window.jSelectAll = document.querySelector('.j-select-all');

// ** CHECKBOXES **


//CUSTOM CHECKBOX BEHAVIOUR

$(".selectable-table td").click(function(e) {
  if (e.target.type == "checkbox") {
    // stop the bubbling to prevent firing the row's click event
    // e.stopPropagation();
  } else {
    var $checkbox = $(this).find(':checkbox');
    $checkbox.attr('checked', !$checkbox.attr('checked'))
    ;
  }
});

window.setCheckbox = function setCheckbox(elem){
  if($(elem).is(':checked')){
   $(elem).prev('.custom-checkbox').addClass('checked');
   $(elem).closest('tr').addClass('is-selected');
 }else{
   $(elem).prev('.custom-checkbox').removeClass('checked');
   $(elem).closest('tr').removeClass('is-selected');
 }
};

$(document).ready(function(){
        // apply custom checkbox on page ready
        $('.j-selectable').before('<span class="custom-checkbox">');
        $('.j-select-all').before('<span class="custom-checkbox custom-select-all" id="j-select-all-custom">');
        $('.j-selectable').each(function(){
          setCheckbox($(this))
        });
        $('.j-select-all').each(function(){
          setCheckbox($(this))
        });
      });

// on input change, change custom checkbox
$('body').on('change', '.default_checkbox', function(){
  setCheckbox($(this));
});

//SELECT ALL CHECKBOXES

window.toggleCheckBoxes = function toggleCheckBoxes(source) {
  checkboxes = document.getElementsByName('items_ids[]');
  for(var i=0, n=checkboxes.length;i<n;i++) {
    checkboxes[i].checked = source.checked;
    setCheckbox(checkboxes[i]);;;
  }
};


//CLICKABLE ROWS

window.dropDownButton = document.querySelector("#dropdownMenuButton");

function clickableRow(e) {
  if (e.target.closest("tr") !== null) {
    const targetCheckbox = e.target.closest("tr").getElementsByClassName('default_checkbox')[0] || "";
    if ((e.target.parentNode.closest("tr").classList.contains('j-clickable-row')) && ((e.target.parentNode.closest("div").classList.contains('dropup') !== true) && (e.target.parentNode.closest("div").classList.contains('dropdown-menu') !== true) && (e.target.classList.contains('btn')  !== true) && (e.target.parentNode.closest("div").classList.contains('is-link') !== true))) {
      if (targetCheckbox.checked == false) {
        targetCheckbox.checked = true;
        targetCheckbox.previousSibling.classList.add("checked");
        targetCheckbox.closest("tr").classList.add("is-selected");
      } else {
        if ((targetCheckbox !== "") && (targetCheckbox !== null)) {
          targetCheckbox.checked = false;
          targetCheckbox.previousSibling.classList.remove("checked");
          targetCheckbox.closest("tr").classList.remove("is-selected");
        }
      }
    }
  }
}

document.addEventListener("change", clickableRow);
document.addEventListener("click", clickableRow);





//CLOSE ACTION TABLE BAR CANCELLING EVERY PREVIOUS SELECTION

// let closeIcone = document.querySelector('.icon-close-circle');
window.test = document.querySelectorAll('.custom-checkbox');
window.checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
window.arrayItemsId = [];

document.addEventListener('click', function(e) {
  let test = document.querySelectorAll('.custom-checkbox');
  let checkboxes = document.querySelectorAll('.default_checkbox');
  if ((e.target.classList.contains("icon-close-circle")) || (e.target.parentNode && e.target.parentNode.classList.contains("icon-close-circle"))) {
    targetDiv.style.display = "none";
    arrayItemsId = []
    if (inputItemsId1) {
      inputItemsId1.value = `[${arrayItemsId}]`;
    }
    inputItemsId2.value = "";
    checkboxes.forEach (function(checkbox){
      checkbox.checked = false;
      checkbox.previousSibling.classList.remove('checked');
      checkbox.closest("tr").classList.remove('is-selected');
    })
  }
});

//AUTO SIZING OF TABLE ACTION BAR

function resizeActionBar() {
 var tableWidth = $('.sidebar__wrapper').width();
 var tableWidthCalculated = (tableWidth * 0.86);
 $('.table-action-bar').css('width', tableWidthCalculated + 'px');
}
$(document).ready(function(){
  resizeActionBar()
});


var width = $(window).width();
$(window).on('resize', function() {
  if ($(this).width() != width) {
    resizeActionBar();
  }
});

//HORIZONTALLY ADJUSTING TABLE ACTION BAR

$(function () {
  var $blue = $(".blue"),
  $pg = $(".sidebar__wrapper"),
  $document = $(document),
  left = 0,
  scrollTimer = 0;

  $document.on("scroll", function () {
    var docLeft = $document.scrollLeft();
    if(left !== docLeft) {
      var self = this, args = arguments;
      if(!scrollTimer) {
        // We've not yet (re)started the timer: It's the beginning of scrolling.
        startHScroll.apply(self, args);
      }
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        scrollTimer = 0;
        // Our timer was never stopped: We've finished scrolling.
        stopHScroll.apply(self, args);
      }, 100);
      left = docLeft;
    }
  });
// Horizontal scroll started - Make div's absolutely positioned.
function startHScroll () {
  $(".table-action-bar")

// Clear out any left-positioning set by stopHScroll.
.css("text-align","center")
.each(function () {
  var $this = $(this),
  pos = $this.offset();
// Preserve our current vertical position...
$this.css("top", pos.top)
})
// ...before making it absolutely positioned.
.css("position", "absolute");
}
// Horizontal scroll stopped - Make div's float again.
function stopHScroll () {
  var leftScroll = $(window).scrollLeft();
  $(".table-action-bar")

// Clear out any top-positioning set by startHScroll.
.css("top","")
.each(function () {
  var $this = $(this),
  pos = $this.position();
      // Preserve our current horizontal position, munus the scroll position...
      $this.css("left", pos.left-leftScroll);
    })
    // ...before making it fixed positioned.
    .css("position", "fixed");
  }
});
